function SectionCandidateSocialInfo() {
    return (
        <>
            <form>
                <div className="panel panel-default">
                    <div className="panel-heading wt-panel-heading p-a20">
                        <h4 className="panel-tittle m-a0">Social Network</h4>
                    </div>
                    <div className="panel-body wt-panel-body p-a20 m-b30 ">
                        <div className="row">
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Facebook</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control wt-form-control" name="company_name" type="text" placeholder="https://www.facebook.com/" />
                                        <i className="fs-input-icon fab fa-facebook-f" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Twitter</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control wt-form-control" name="company_name" type="text" placeholder="https://twitter.com/" />
                                        <i className="fs-input-icon fab fa-twitter" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>linkedin</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control wt-form-control" name="company_name" type="text" placeholder="https://in.linkedin.com/" />
                                        <i className="fs-input-icon fab fa-linkedin-in" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Whatsapp</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control wt-form-control" name="company_name" type="text" placeholder="https://www.whatsapp.com/" />
                                        <i className="fs-input-icon fab fa-whatsapp" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Instagram</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control wt-form-control" name="company_name" type="text" placeholder="https://www.instagram.com/" />
                                        <i className="fs-input-icon fab fa-instagram" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Pinterest</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control wt-form-control" name="company_name" type="text" placeholder="https://in.pinterest.com/" />
                                        <i className="fs-input-icon fab fa-pinterest-p" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Tumblr</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control wt-form-control" name="company_name" type="text" placeholder="https://www.tumblr.com/" />
                                        <i className="fs-input-icon fab fa-tumblr" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Youtube</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control wt-form-control" name="company_name" type="text" placeholder="https://www.youtube.com/" />
                                        <i className="fs-input-icon fab fa-youtube" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12">
                                <div className="text-left">
                                    <button type="submit" className="site-button">Save Changes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

export default SectionCandidateSocialInfo;